export const PLANALTO_LC116_URL = 'https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm';

export const NFSE_LC116_LIST_URL =
  'https://www.gov.br/nfse/pt-br/mei-e-demais-empresas/codigos-de-tributacao-nacional-nbs';

export const LC116_GOLDEN_ANALISE_SISTEMAS = '1.01';
export const LC116_GOLDEN_OBRAS_CIVIS = '7.02';

export const LC116_MIN_ITEMS = 150;
export const LC116_MAX_ITEMS = 250;
